import { Thread } from "../../../../types"
import ConversationsListItem from "../../conversations-list-item"
import ConversationsListSkeleton from "../../skeletons/conversation-list"

interface Props {
  isLoading: boolean
  filteredThreads: Thread[]
}

const List = ({ isLoading, filteredThreads }: Props) => {
  return isLoading ? (
    <ConversationsListSkeleton />
  ) : (
    <ul className="divide-y divide-neutral-200 overflow-y-auto">
      {filteredThreads && filteredThreads.length > 0 ? (
        filteredThreads.map(thread => (
          <ConversationsListItem thread={thread} key={thread._id} />
        ))
      ) : (
        <li className="flex justify-center py-4">
          No threads found, please try another term.
        </li>
      )}
    </ul>
  )
}

export default List
